// import telemetry from '../../../api/savanna/telemetry.api';
const state = {};

const getters = {
};

const mutations = {};

// currently all telemetry information is returned directly to the calling function
// TODO: determine if it would be worthwhile to capture any of this data in this store otherwise it seems unnecessary
const actions = {
  async getWeatherData(_, { gcuId, query }) {

    const { weatherPoints: data = [] } = await this.$api.get(`/v1/gcus/${gcuId}/weather`, { query });
    return data;
  },
  async getIrradData(_, { gcuId, query }) {
    const { irradiancePoints: data = [] } = await this.$api.get(`/v1/gcus/${gcuId}/irradiance`, { query });
    return data;
  },
  async getSensorData(_, { lcuId, query }) {
    const { sensorData: data = [] } = await this.$api.get(`/v1/trackers/${lcuId}/sensor`, { query });
    return data;
  },
  async getReedData(_, { lcuId, query }) {
    const { reedonData, reedoffData, stepsData } = await this.$api.get(`/v1/trackers/${lcuId}/reed`, { query });
    return reedonData || reedoffData || stepsData || [];
  },
  async getStatusData(context, { lcuId, query }) {
    const { trackerStatus: data = [] } = await this.$api.get(`/v1/trackers/${lcuId}/sensor`, { query });
    return data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
